import { parseTimeExpression } from '@/utils/parseTimeInput';

import { DateEntry } from '../types';

/**
 * Проверяет, является ли строка duration валидной
 * (не пустая, парсится и больше 0)
 */
export const isValidDuration = (duration: string | undefined): boolean => {
  if (!duration?.trim()) return false;

  const parsed = parseTimeExpression(duration);

  return !!parsed && parsed > 0;
};

/**
 * Проверяет, что все записи в массиве имеют валидный duration
 */
export const areAllEntriesValid = (entries: DateEntry[]): boolean => {
  return entries.every((entry) => isValidDuration(entry.duration));
};
